import toast from 'react-hot-toast';

const baseStyle = {
  borderRadius: '12px',
  padding: '12px 16px',
  fontSize: '0.9rem',
  fontWeight: 500,
  fontFamily: 'var(--font-sans, system-ui, sans-serif)',
  boxShadow: '0 12px 40px rgba(45, 42, 38, 0.14), 0 2px 8px rgba(45, 42, 38, 0.06)',
  maxWidth: '420px',
};

export const toastOptions = {
  position: 'top-center',
  duration: 4200,
  style: {
    ...baseStyle,
    background: '#fffefc',
    color: '#2d2a26',
    border: '1px solid #e8e4df',
  },
  success: {
    duration: 3800,
    iconTheme: {
      primary: '#1d6b4f',
      secondary: '#fffefc',
    },
    style: {
      ...baseStyle,
      background: 'linear-gradient(135deg, #f0faf6 0%, #fffefc 100%)',
      color: '#145a42',
      border: '1px solid rgba(29, 107, 79, 0.25)',
    },
  },
  error: {
    duration: 5200,
    iconTheme: {
      primary: '#c62828',
      secondary: '#fffefc',
    },
    style: {
      ...baseStyle,
      background: 'linear-gradient(135deg, #fff5f5 0%, #fffefc 100%)',
      color: '#8b0000',
      border: '1px solid rgba(198, 40, 40, 0.22)',
    },
  },
};

export function toastSuccess(message) {
  if (!message) return;
  toast.success(message, { id: 'toast-success' });
}

export function toastError(message) {
  if (!message) return;
  toast.error(message, { id: 'toast-error' });
}

export function toastInfo(message) {
  if (!message) return;
  toast(message, { id: 'toast-info' });
}
